// extracted by mini-css-extract-plugin
export var productImage = "_qy-1";
export var viewLink = "_qy-2";
export var wishlistItem = "_qy-0";